import { RootState } from 'src/store';
import { NewProjectDefinitionFormState, defaultProjectDefinitionFormState } from './newProjectDefinitionSlice';

export const getCurrentProjectDefinitionFormState = (state: RootState): NewProjectDefinitionFormState => {
    const formState = state.projects.newProjectDefinition.formState;

    if (!formState) {
        return defaultProjectDefinitionFormState;
    }

    return formState;
};
